<template>
  <common-dialog ref="dialog" width="450px" title="商品同步" :data="data" @closed="onClosed"
    @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item label="开始时间">
        <el-date-picker v-model="data.startTime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          placeholder="选择开始时间" />
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker v-model="data.endTime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          placeholder="选择结束时间" />
      </el-form-item>
    </template>
    <template slot="footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="handleSync">同 步</el-button>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from '@/components/common/dialog';
import dayjs from 'dayjs'

export default {
  components: { commonDialog },
  data() {
    return {
      data: {
        startTime: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
        endTime: dayjs().format('YYYY-MM-DD'),
      },
    }
  },
  methods: {
    open() {
      this.$refs.dialog.open();
    },
    handleSync() {
      this.$emit('close-saved', { ...this.data });
      this.$refs.dialog.close();
    },
    close() {
      this.$refs.dialog.close();
    },
    onClosed() {

    },
  }
}
</script>
